import { motion } from "framer-motion";
import { Factory, ShieldCheck, Ban } from "lucide-react";
import { IMAGES } from "../data";
import { CupMark } from "./Logo";

const CHIPS = [
  { icon: Factory, text: "High-speed cup forming lines" },
  { icon: ShieldCheck, text: "QC checked on every batch" },
  { icon: Ban, text: "Zero outsourcing. Zero brokers." },
];

export const Manufacturing = () => (
  <section id="manufacturing" className="relative py-24 sm:py-32 bg-[#170A38] text-[#FAF7F2] overflow-hidden grain" data-testid="manufacturing-section">
    <div className="absolute -top-24 -left-24 w-[26rem] h-[26rem] rounded-full bg-[#FF5A36]/15 blur-3xl" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#FBBF24] mb-4" data-testid="manufacturing-eyebrow">
          In-House Manufacturing
        </p>
        <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight" data-testid="manufacturing-headline">
          We don't broker cups.{" "}
          <span className="italic text-[#FF5A36]">We manufacture them.</span>
        </h2>
        <p className="mt-5 text-[#FAF7F2]/70 leading-relaxed max-w-lg">
          Every Cup Connect cup is formed, printed and packed inside our own
          facility — from raw paper roll to sealed carton, under one roof. No
          middlemen, no re-traders. That's how we hold food-safe quality on
          every batch, keep prices honest, and still dispatch in 15 days.
        </p>
        <div className="mt-9 space-y-3.5" data-testid="manufacturing-chips">
          {CHIPS.map((c) => (
            <div key={c.text} className="flex items-center gap-3 font-semibold text-[#FAF7F2]/85">
              <span className="w-10 h-10 rounded-2xl bg-[#FF5A36]/20 flex items-center justify-center shrink-0">
                <c.icon className="w-5 h-5 text-[#FBBF24]" />
              </span>
              {c.text}
            </div>
          ))}
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="relative"
      >
        <div className="rounded-[2.5rem] overflow-hidden border border-white/10 shadow-2xl rotate-1">
          <img
            src={IMAGES.factory}
            alt="Cup Connect paper cup manufacturing facility"
            className="w-full h-80 sm:h-[26rem] object-cover"
            data-testid="manufacturing-image"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#170A38]/60 via-transparent to-transparent" />
        </div>
        <div
          className="absolute -bottom-6 left-6 flex items-center gap-3 bg-[#FAF7F2] text-[#2E1065] rounded-2xl px-5 py-4 shadow-2xl -rotate-2"
          data-testid="manufacturing-brand-badge"
        >
          <CupMark className="w-10 h-10" />
          <div>
            <p className="font-display font-black leading-tight">Cup Connect</p>
            <p className="text-xs font-bold text-[#FF5A36] uppercase tracking-widest">Manufacturing Unit · India</p>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);
